<script lang="ts">
    import Icon from "@components_v2/Icon.svelte";
    import ChatReferralIcon from "@components_v2/Icons/ChatReferralIcon.svelte";

    import T from "@components/T.svelte";
    import TooltipActivator from "@components/Tooltip/TooltipActivator.svelte";

    export let namespace: string;
</script>

<TooltipActivator position="bottom-end">
    <svelte:fragment>
        <Icon class="gw-rv-meta__icon" width={20} height={20}>
            <ChatReferralIcon />
        </Icon>
    </svelte:fragment>

    <svelte:fragment slot="content">
        <T {namespace} translationKey="review_imported" />
    </svelte:fragment>
</TooltipActivator>

<style lang="postcss">
    .gw-rv-meta {
        :global(&__icon) {
            display: flex;
            align-items: center;
            justify-content: center;
            transition: box-shadow 0.2s ease;
            border-radius: 50%;

            &:hover {
                box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
                background: rgba(0, 0, 0, 0.05);
            }
        }
    }
</style>
